import { useEffect, useState } from 'react';
import { usePlayerStore } from '../stores/playerStore';
import { sleepTimerService } from '../services/sleepTimerService';

/**
 * Live "mm:ss" for an armed sleep timer, or null when none is running.
 *
 * Setting a timer previously gave no lasting feedback at all — the modal closed,
 * a toast faded, and the only trace was a faint pulse on the moon icon. With
 * every preset at 15 minutes or more there was no way to tell it had armed.
 */
export const useSleepCountdown = (): string | null => {
  const sleepTimer = usePlayerStore((state) => state.sleepTimer);
  const [remaining, setRemaining] = useState<number | null>(() =>
    sleepTimerService.getDisplayTime()
  );

  useEffect(() => {
    const read = () => setRemaining(sleepTimerService.getDisplayTime());
    read();

    // Display only — the actual stop is driven by the audio pipeline in
    // sleepTimerService, so throttling here costs nothing but a stale label.
    const id = window.setInterval(read, 1000);
    return () => window.clearInterval(id);
  }, [sleepTimer]);

  if (remaining === null || remaining <= 0) return null;

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
